import { createFileRoute } from '@tanstack/react-router'
import shouldBeLoggedIn from '#app/guards/should-be-logged-in'

export const Route = createFileRoute('/client/_pre-registration-required')({
  loader: async () => {
    await shouldBeLoggedIn()
  },
})
